import { render } from "./qzjgaojingdetail.vue?vue&type=template&id=6c979b40&scoped=true&ts=true"
import script from "./qzjgaojingdetail.vue?vue&type=script&lang=ts"
export * from "./qzjgaojingdetail.vue?vue&type=script&lang=ts"

import "./qzjgaojingdetail.vue?vue&type=style&index=0&id=6c979b40&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c979b40"]])

export default __exports__